@let currentSelectedId = selectedOptionId();
@let currentDraft = personDraft();

<section
  class="wishlist-create-beneficiary-selector"
  aria-label="Dla kogo jest lista"
>
  <div class="wishlist-create-beneficiary-selector__options">
    <ui-choice-group
      ariaLabel="Wybierz osobę dla wishlisty"
      [options]="choiceOptions()"
      [selectedOptionId]="currentSelectedId"
      layout="stack"
      [required]="true"
      [invalid]="errors().beneficiary !== null"
      [describedBy]="
        errors().beneficiary ? 'wishlist-create-beneficiary-error' : null
      "
      (selectedOptionIdChange)="handleOptionSelected($event)"
    />
  </div>

  @if (errors().beneficiary) {
    <p
      id="wishlist-create-beneficiary-error"
      class="wishlist-create-beneficiary-selector__error"
      role="alert"
    >
      {{ errors().beneficiary }}
    </p>
  }

  @if (selectedOption(); as selected) {
    <div class="wishlist-create-beneficiary-selector__selection-note">
      <span aria-hidden="true">{{ selected.avatarLabel }}</span>
      <p>
        Ta wishlista będzie przypisana do
        <strong>{{ selected.displayName }}</strong
        >.
      </p>
    </div>
  }

  @if (!addPersonOpen()) {
    <ui-action-card
      class="wishlist-create-beneficiary-selector__add"
      title="Dodaj osobę"
      description="Utwórz prosty profil domownika"
      (selected)="handleAddPersonOpened()"
    >
      <span uiActionCardLeading aria-hidden="true">+</span>
    </ui-action-card>
  } @else {
    <ui-card class="wishlist-create-beneficiary-selector__inline-form">
      <ui-input
        label="Imię"
        name="newBeneficiaryName"
        placeholder="np. Marysia"
        [value]="currentDraft.displayName"
        [required]="true"
        (valueChange)="handlePersonNameChange($event)"
      />

      <ui-input
        label="Relacja"
        name="newBeneficiaryRelation"
        placeholder="np. Córka"
        [value]="currentDraft.relationLabel"
        (valueChange)="handlePersonRelationChange($event)"
      />

      <ui-switch-row
        title="Pozwól tej osobie się logować"
        description="Własne konto od 13 lat. Ta opcja nie tworzy konta ani nie włącza AI."
        [checked]="currentDraft.loginAllowed"
        (checkedChange)="handlePersonLoginAllowedChange($event)"
      />

      @if (personCreateError()) {
        <p class="wishlist-create-beneficiary-selector__error" role="alert">
          {{ personCreateError() }}
        </p>
      }

      <div class="wishlist-create-beneficiary-selector__actions">
        <ui-button
          variant="secondary"
          [disabled]="personCreatePending()"
          (pressed)="handleAddPersonClosed()"
        >
          Anuluj
        </ui-button>
        <ui-button
          [disabled]="personCreatePending() || personCreateDisabled()"
          (pressed)="handleCreatePersonSelected()"
        >
          Dodaj osobę
        </ui-button>
      </div>
    </ui-card>
  }
</section>
